import * as React from "react";
import { Row, Col, Form, notification } from "antd";
import StandardButton from "src/components/common/StandardButton/StandardButton";
import { useContext, useState } from "react";
import { FormComponentProps } from "antd/lib/form";
import { PbrSeparator } from "src/components/common/Separator/Separator";
import PbrDocUploader, { IFileToUpload } from "src/components/common/PbrDocUploader/PbrDocUploader";
import { IVendaProps } from "src/services/interfaces/IVendaProps";
import { ServiceContext } from "src/services/provider/Service.provider";
import "./documents.scss";
import { IDocumentUpload } from 'src/services/interfaces/IDocumentUpload';
import { DocumentCategoryEnum } from 'src/components/Refatoracao/UploadDocument/DocumentCategoryEnum';
import { StorageTypeEnum } from 'src/components/Refatoracao/UploadDocument/StorageTypeEnum';

function Documents(props: FormComponentProps & IVendaProps) {
  const { tradeService } = useContext(ServiceContext);
  const [loading, setLoading] = useState(false);
  const [docRg, setDocRg] = useState<any>(null);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    const documentUpload: IDocumentUpload = {
      category: DocumentCategoryEnum.ID_OWNER,
      tradeId: props.trade.id,
      storageType: StorageTypeEnum.S3,
      file: docRg.file,
      fileName: docRg.name,
      uploadDate: new Date(),
      executeActionAfterUpload: false,
      path: "",
      id: 0
    };

    tradeService
      .putUploadDocument(documentUpload)
      .then(res => {
        props.onChangePhase(res.phase);
      })
      .catch(error => {
        notification.error({
          message: "Ocorreu um erro",
          description: error.response.data.message
        });
      })
      .finally(() => setLoading(false));
  }

  function handleChange(fileToUpload: IFileToUpload) {
    fileToUpload.type = "ID_OWNER";
    setDocRg(fileToUpload);
  }

  return (
    <div className="documents steps-container">
      <Form onSubmit={handleSubmit}>
        <h1>Completar cadastro</h1>
        <div className="steps-container-description">
          <p>Envie uma foto do RG, CNH ou outro documento com foto do proprietário do precatório. (somente PNG ou JPG)</p>
        </div>
        <Row type="flex" justify="center" align="middle" className="document-row">
          <Col xs={24} sm={24} md={24} lg={24}>
            <PbrDocUploader btnText="Subir RG do titular" title="" onChangeBase64={val => handleChange(val)} />
          </Col>
        </Row>
        <PbrSeparator />
        <Row type="flex" justify="center" align="middle" style={{ marginBottom: "50px" }}>
          <Col xs={24} sm={24} md={24} lg={24} style={{ textAlign: "center" }}>
            <StandardButton disabled={!docRg} loading={loading} htmlType="submit" style={{ margin: "auto" }}>
              Enviar
            </StandardButton>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default Form.create()(Documents);



// WEBPACK FOOTER //
// ./src/pages/step-flow/steps/documents/Documents.tsx